import React from 'react';
import { ReactComponent as CloseSvg } from 'assets/icons/New/FilterBar/Close.svg';
import { ReactComponent as SaveToSvg } from 'assets/icons/New/FilterBar/SaveTo.svg';
import { ReactComponent as SetDatesSvg } from 'assets/icons/New/FilterBar/SetDates.svg';
import { ReactComponent as ArchiveSvg } from 'assets/icons/New/FilterBar/Archive.svg';
import { ReactComponent as UnarchiveSvg } from 'assets/icons/New/FilterBar/Unarchive.svg';
import { ReactComponent as DownloadSvg } from 'assets/icons/New/FilterBar/Download.svg';
import { ReactComponent as ShareSvg } from 'assets/icons/New/FilterBar/Share.svg';
import { ReactComponent as RenameSvg } from 'assets/icons/New/FilterBar/Rename.svg';
import { ReactComponent as DeleteSvg } from 'assets/icons/New/FilterBar/Delete.svg';
import { ReactComponent as RestoreSvg } from 'assets/icons/New/FilterBar/Restore.svg';
import { ReactComponent as MoveSvg } from 'assets/icons/New/FilterBar/Move.svg';
import { ReactComponent as SetDataSvg } from 'assets/icons/New/FilterBar/SetData.svg';

export const ITEM_TYPE = {
  SELECT: 'SELECT',
  SAVE_TO: 'SAVE_TO',
  SET_DATA: 'SET_DATA',
  SAVE_TO_SET_DATA: 'SAVE_TO_SET_DATA',
  SET_DATES: 'SET_DATES',
  ARCHIVE: 'ARCHIVE',
  UN_ARCHIVE: 'UN_ARCHIVE',
  DOWNLOAD: 'DOWNLOAD',
  SHARE: 'SHARE',
  SHARE_EMAIL: 'SHARE_EMAIL',
  RENAME: 'RENAME',
  EDIT_TYPE: 'EDIT_TYPE',
  MOVE: 'MOVE',
  RESTORE: 'RESTORE',
  DELETE: 'DELETE',
  REMOVE: 'REMOVE',
};

export const ITEMS = [
  {
    type: ITEM_TYPE.SELECT,
    label: 'Select',
    icon: <CloseSvg />,
  },
  {
    type: ITEM_TYPE.SET_DATA,
    label: 'Set Data',
    icon: <SetDataSvg />,
    tooltip: 'Set data for the document',
  },
  {
    type: ITEM_TYPE.SAVE_TO,
    label: 'Save To',
    icon: <SaveToSvg />,
    tooltip: 'Save document to a specific module, such as Product Management',
  },
  {
    type: ITEM_TYPE.SAVE_TO_SET_DATA,
    label: 'Save To & Set Data',
    icon: <SaveToSvg />,
    tooltip: 'Save document to a specific module, such as Product Management',
  },
  {
    type: ITEM_TYPE.SET_DATES,
    label: 'Set Dates & Reminder',
    icon: <SetDatesSvg />,
    tooltip: 'Set expiry date, review date and email reminder for document',
  },
  {
    type: ITEM_TYPE.ARCHIVE,
    label: 'Archive',
    icon: <ArchiveSvg />,
    tooltip: 'Archive document to the “Archived” list',
  },
  {
    type: ITEM_TYPE.UN_ARCHIVE,
    label: 'Unarchive',
    icon: <UnarchiveSvg />,
    tooltip: 'Remove document from the “Archived" list and return it to other lists',
  },
  {
    type: ITEM_TYPE.DOWNLOAD,
    label: 'Download',
    icon: <DownloadSvg />,
    tooltip: 'Download document to your device',
  },
  {
    type: ITEM_TYPE.SHARE,
    label: 'Share',
    icon: <ShareSvg />,
    tooltip: 'Share document via a unique link',
  },
  {
    type: ITEM_TYPE.RENAME,
    label: 'Rename',
    icon: <RenameSvg />,
    tooltip: 'Rename document',
  },
  {
    type: ITEM_TYPE.EDIT_TYPE,
    label: 'Edit Type',
    icon: <RenameSvg />,
    tooltip: 'Change the document type',
  },
  {
    type: ITEM_TYPE.MOVE,
    label: 'Move',
    icon: <MoveSvg />,
    tooltip: 'Move document',
  },
  {
    type: ITEM_TYPE.RESTORE,
    label: 'Restore',
    icon: <RestoreSvg />,
    tooltip: 'Restore a previously deleted document',
  },
  {
    type: ITEM_TYPE.DELETE,
    label: 'Delete',
    icon: <DeleteSvg />,
    tooltip: 'Delete document',
  },
  {
    type: ITEM_TYPE.REMOVE,
    label: 'Remove',
    icon: <DeleteSvg />,
    tooltip: 'Remove document',
  },
];

export const MODULE_TEXT = {
  DOCUMENT_MANAGEMENT: 'document-management',
  PRODUCT_PROFILE: 'product-profile',
  PRODUCT_TESTING: 'product-testing',
  QC_INSPECTION: 'qc-inspection',
  INTERNAL_INSPECTION: 'internal-inspection',
};

export const getModuleText = (selectedRows) => {
  const selectedCount = selectedRows?.length;
  const tFiles = (selectedRows || []).filter((obj) => !obj.isFolder);
  const tFolders = (selectedRows || []).filter((obj) => !!obj.isFolder);
  return {
    [MODULE_TEXT.DOCUMENT_MANAGEMENT]: {
      [ITEM_TYPE.SET_DATA]: {
        title: 'Are you sure to overwrite data on documents?',
        description:
          'One or more of the selected documents contain data. Proceeding will overwrite the existing data in all selected documents.',
        submitText: 'Proceed',
      },
      [ITEM_TYPE.SET_DATES]: {
        title: 'Are you sure to overwrite data on documents?',
        description:
          'One or more of the selected documents contain data. Proceeding will overwrite the existing data in all selected documents.',
        submitText: 'Proceed',
      },
      [ITEM_TYPE.SAVE_TO]: {
        title: 'Are you sure to overwrite data on documents?',
        description:
          'One or more of the selected documents contain data. Proceeding will overwrite the existing data in all selected documents.',
        submitText: 'Proceed',
      },
      [ITEM_TYPE.SAVE_TO_SET_DATA]: {
        title: 'Are you sure to overwrite data on documents?',
        description:
          'One or more of the selected documents contain data. Proceeding will overwrite the existing data in all selected documents.',
        submitText: 'Proceed',
      },
      [ITEM_TYPE.EDIT_TYPE]: {
        title: 'Are you sure to overwrite data on documents?',
        description:
          'One or more of the selected documents contain data. Proceeding will overwrite the existing data in all selected documents.',
        submitText: 'Proceed',
      },
      [ITEM_TYPE.ARCHIVE]: {
        title: 'Archive document?',
        description: 'Document will be moved to the “Archived” list.',
        submitText: 'Archive',
      },
      [ITEM_TYPE.UN_ARCHIVE]: {
        title: 'Unarchive document?',
        description:
          'Document will be removed from the “Archived” list and returned to other lists.',
        submitText: 'Unarchive',
      },
      [ITEM_TYPE.DELETE]: {
        title:
          selectedCount > 1
            ? `Delete ${selectedCount} Documents`
            : 'Are you sure you want to delete?',
        description: 'Document will be deleted from the list.',
        submitText: 'Delete',
      },
    },
    [MODULE_TEXT.PRODUCT_PROFILE]: {
      [ITEM_TYPE.SET_DATES]: {
        title: 'Are you sure to overwrite data on documents?',
        description:
          'One or more of the selected documents contain data. Proceeding will overwrite the existing data in all selected documents.',
        submitText: 'Confirm and Edit',
      },
      [ITEM_TYPE.SAVE_TO]: {
        title: 'Are you sure to overwrite data on documents?',
        description:
          'One or more of the selected documents contain data. Proceeding will overwrite the existing data in all selected documents.',
        submitText: 'Proceed',
      },
      [ITEM_TYPE.SAVE_TO_SET_DATA]: {
        title: 'Are you sure to overwrite data on documents?',
        description:
          'One or more of the selected documents contain data. Proceeding will overwrite the existing data in all selected documents.',
        submitText: 'Proceed',
      },
      [ITEM_TYPE.EDIT_TYPE]: {
        title: 'Are you sure to overwrite data on documents?',
        description:
          'One or more of the selected documents contain data. Proceeding will overwrite the existing data in all selected documents.',
        submitText: 'Proceed',
      },
      [ITEM_TYPE.ARCHIVE]: {
        title: 'Archive document?',
        description: (
          <>
            <div>Document will be moved to the “Archived” list.</div>
            <div>
              It will reflect in the Original Document and other related product / supplier profile.
            </div>
          </>
        ),
        submitText: 'Archive',
      },
      [ITEM_TYPE.UN_ARCHIVE]: {
        title: 'Unarchive document?',
        description: (
          <>
            <div>Document will be removed from the “Archived” list.</div>
            <div>
              It will reflect in the Original Document and other related product / supplier profile.
            </div>
          </>
        ),
        submitText: 'Unarchive',
      },
      [ITEM_TYPE.SET_DATA]: {
        title: 'Are you sure to overwrite data on documents?',
        description: (
          <>
            One or more of the selected documents contain data. Proceeding will overwrite the
            existing data in all selected documents.
          </>
        ),
        submitText: 'Proceed',
      },
      [ITEM_TYPE.REMOVE]: {
        title: `Are you sure to remove document${
          selectedCount === 1 ? '' : 's'
        } from this product ?`,
        description:
          selectedCount > 1 ? (
            <>
              <div>
                <div>Below items will be removed:</div>
                <ul>
                  <li>
                    {tFolders.length} folder{tFolders.length === 1 ? '' : 's'}
                  </li>
                  <li>
                    {tFiles.length} document{tFiles.length === 1 ? '' : 's'}
                  </li>
                </ul>
                <div>
                  The documents will remain in Document Management after being removed from this
                  product.
                </div>
              </div>
            </>
          ) : (
            'The document will remain in Document Management after being removed from this product.'
          ),
        submitText: 'Remove',
      },
    },
    [MODULE_TEXT.PRODUCT_TESTING]: {
      [ITEM_TYPE.SAVE_TO_SET_DATA]: {
        title: 'Are you sure to overwrite data on documents?',
        description:
          'One or more of the selected documents contain data. Proceeding will overwrite the existing data in all selected documents.',
        submitText: 'Proceed',
      },
    },
    [MODULE_TEXT.QC_INSPECTION]: {
      [ITEM_TYPE.SAVE_TO_SET_DATA]: {
        title: 'Are you sure to overwrite data on documents?',
        description:
          'One or more of the selected documents contain data. Proceeding will overwrite the existing data in all selected documents.',
        submitText: 'Proceed',
      },
    },
    [MODULE_TEXT.INTERNAL_INSPECTION]: {
      [ITEM_TYPE.SAVE_TO_SET_DATA]: {
        title: 'Are you sure to overwrite data on documents?',
        description:
          'One or more of the selected documents contain data. Proceeding will overwrite the existing data in all selected documents.',
        submitText: 'Proceed',
      },
    },
  };
};
